import type { ICameraRepository } from '@yawi/domain';
import type { CameraListResponse, HikVersionResponse } from '@yawi/types';
import { getApiClient, getApiBaseUrl, tenantHeaders } from '../../http/apiClient';

export class ApiCameraRepository implements ICameraRepository {
  async checkConnection(): Promise<HikVersionResponse> {
    const client = getApiClient();
    return await client.get<HikVersionResponse>('v1/devices/hikcentral/version');
  }

  async listCameras(page = 1, limit = 50, tenantId?: string): Promise<CameraListResponse> {
    const client = getApiClient();
    return await client.get<CameraListResponse>('v1/devices/hikcentral/cameras', {
      params: { page, limit },
      ...tenantHeaders(tenantId),
    });
  }

  async getStreamUrl(indexCode: string): Promise<string> {
    const client = getApiClient();
    const response = await client.get<{ streamUrl: string }>(
      `v1/devices/hikcentral/cameras/${indexCode}/stream`
    );
    // streamUrl is "/api/devices/..." (absolute path from host root)
    // Extract origin from base URL (e.g., "http://localhost:3000") and prepend
    const baseUrl = getApiBaseUrl();
    const origin = baseUrl ? new URL(baseUrl).origin : '';
    return `${origin}${response.streamUrl}`;
  }

  async captureSnapshot(indexCode: string): Promise<string> {
    const client = getApiClient();
    const response = await client.post<{ imageData: string }>(
      `v1/devices/hikcentral/cameras/${indexCode}/capture`
    );
    const imageData = response.imageData ?? '';
    // Backend already includes the data URI prefix — avoid double-prefixing.
    return imageData.startsWith('data:')
      ? imageData
      : `data:image/jpeg;base64,${imageData}`;
  }
}
